import React, { useState } from "react";
import { IDoctor } from "../../../../dto/interfaces";
import BookingToggle from "./BookingToggle";
import Booking from "../../../Booking/Booking";
import { WhatsAppButton } from "../../../../components/WhatsappComponent";

export type BookingMethod = "online" | "whatsapp";

interface BookingSectionProps {
    doctor: IDoctor;
}

/**
 * The main "Appointment Booking" section.
 * Manages the state for switching between Online and WhatsApp booking.
 */
export const BookingSection: React.FC<BookingSectionProps> = ({ doctor }) => {
    // State to manage which tab is active
    const [bookingMethod, setBookingMethod] = useState<BookingMethod>("online");

    return (
        <section id="book-appointment" className="py-16 md:py-24 bg-white">
            <div className="container mx-auto px-6 max-w-4xl">
                {/* --- Section Title --- */}
                <div className="text-center mb-10">
                    <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">Appointment Booking</h2>
                </div>

                {/* --- The Tab Toggle --- */}
                <BookingToggle activeMethod={bookingMethod} onMethodChange={setBookingMethod} />

                {/* --- The Content Area --- */}
                <div className="mt-10">
                    {/* Show WEBSITE (Online) booking flow */}
                    {bookingMethod === "online" && (
                        // 2. RENDER YOUR EXISTING BOOKING FLOW
                        <Booking doctor={doctor} />
                    )}

                    {/* Show WHATSAPP booking flow */}
                    {bookingMethod === "whatsapp" && (
                        <WhatsAppButton
                            connectionId={doctor.alias}
                            doctorName={doctor?.name}
                            doctorId={doctor?.id}
                            showQr
                            showPhone
                        />
                    )}
                </div>
            </div>
        </section>
    );
};
